import { useCallback, useState } from 'react';

import {
  SortInput,
  SortOrder,
} from 'apps/shared/scripts/__generated__/graphql.generated';
import { useInvoices } from 'apps/shared/scripts/graphql';

import { InvoicesTable, LoadingInvoices } from '../../components';

const INVOICE_FETCH_LIMIT = 10;

const InvoicesContainer = () => {
  const [sort, setSort] = useState<SortInput>({
    sortBy: 'invoiceNumber',
    sortOrder: SortOrder.Desc,
  });
  const { invoices, isLoading, fetchMore, cursor, hasNextPage, refetch } =
    useInvoices({
      fetchPolicy: 'cache-and-network',
      variables: {
        first: INVOICE_FETCH_LIMIT,
        ...sort,
      },
    });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onSort = useCallback(
    async (sortInput: SortInput) => {
      setSort(sortInput);
      await refetch({
        first: 100,
        ...sortInput,
      });
    },
    [refetch],
  );

  if (isLoading) {
    return <LoadingInvoices />;
  }

  return (
    <InvoicesTable
      invoices={invoices}
      cursor={cursor}
      fetchMore={fetchMore}
      hasNextPage={hasNextPage}
    />
  );
};

InvoicesContainer.displayName = 'InvoicesContainer';

export default InvoicesContainer;
